// @flow

// State Configuration
export const MAP_BRANCH = 'mapModule'

// Branch props
export const PROP_SOIL_PROPS_MAP_BLOB_ID = 'soilPropsMapBlobId'

// End point
export const MAP_ROUTE_ASSETS_TAB = '/map'
export const MAP_ROUTE_JOBS_TAB = '/map/jobs'
export const MAP_ROUTE_SEARCH_TAB = '/map/search'
export const REPORT_URL = 'report'
export const SOIL_PROPERTIES_MAP = 'Soil Properties Map'

// arcgisonline
export const ARCGIS_ONLINE = '//server.arcgisonline.com/ArcGIS'
export const MAP_URL_ESRI = `${ARCGIS_ONLINE}/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg`
export const MAP_URL_OSM = '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
export const MAP_URL_BOUNDARIES =
  `${ARCGIS_ONLINE}/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}.jpg`
export const MAP_URL_DEFAULT = MAP_URL_ESRI

// Map types
export const MAP_TYPES = [{
  name: 'ESRI',
  urls: [MAP_URL_ESRI],
}, {
  name: 'Hybrid',
  urls: [MAP_URL_ESRI, MAP_URL_BOUNDARIES],
}, {
  name: 'Open Street Map',
  urls: [MAP_URL_OSM],
}]

// Action types
export const PRESELECTED_JOB = 'PRESELECTED_JOB'
export const CLEAR_MAP_URL_FROM_JOB_ID = 'CLEAR_MAP_URL_FROM_JOB_ID'
export const LOAD_SOIL_PROPS_MAP_DATA = 'LOAD_SOIL_PROPS_MAP_DATA'
export const SET_SOIL_PROPS_MAP_BLOB_ID = 'SET_SOIL_PROPS_MAP_BLOB_ID'
export const PRESELECTED_JOB_SET = 'PRESELECTED_JOB_SET'

// Grid tool configs
export const SIZE_TOOL_CONFIG = {
  LABEL: 'Size:',
  VALUE_LABEL: 'size',
  MIN_VALUE: 0.25,
  MAX_VALUE: 10,
  STEP: 0.25,
  DEFAULT_VALUE: 5,
  ROUND_COEF: 1 / 0.25,
}

export const ROTATE_TOOL_CONFIG = {
  LABEL: 'Rotate:',
  VALUE_LABEL: 'rotation',
  MIN_VALUE: -180,
  MAX_VALUE: 180,
  STEP: 10,
  DEFAULT_VALUE: 0,
  ROUND_COEF: 1 / 10,
}

// Soil properties map PDF generation status
export const SOIL_PROPS_PDF_NOT_GENERATED = 'SOIL_PROPS_PDF_NOT_GENERATED'
